import { render, staticRenderFns } from "./FinalGroup.vue?vue&type=template&id=7c313231&scoped=true&"
import script from "./FinalGroup.vue?vue&type=script&lang=js&"
export * from "./FinalGroup.vue?vue&type=script&lang=js&"
import style0 from "./FinalGroup.vue?vue&type=style&index=0&id=7c313231&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c313231",
  null
  
)

export default component.exports